import React from 'react';
import {
  bool, node, oneOfType, number, string
} from 'prop-types';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { StorePodContext } from './StorePod.context';
import { StorePodRating } from './modules/StorePodRating';
import { storeDataModel } from './storeDataModel';
import { storeShape } from './storeShape';

const StorePodComponent = ({
  children,
  loading,
  store,
  storeId
}) => {

  const fetchDataInternally = !!storeId;

  let contextValue = {
    isCanadianStore: store?.address?.country?.toUpperCase() === 'CA',
    isDesignStore: store?.storeType === 'hddc',
    loading,
    store: store || {}
  };

  const options = {
    variables: {
      storeSearchInput: storeId,
      pagesize: '1'
    },
    skip: !fetchDataInternally
  };

  const { data, error } = useDataModel('storeSearch', options);

  if (fetchDataInternally) {
    const storeObj = data?.storeSearch?.stores[0] || {};

    contextValue = {
      isCanadianStore: storeObj?.address?.country?.toUpperCase() === 'CA',
      isDesignStore: storeObj?.storeType === 'hddc',
      loading: !storeObj?.storeId,
      store: storeObj
    };
  }

  return (
    <div>
      <StorePodContext.Provider value={contextValue}>
        {children}
      </StorePodContext.Provider>
    </div>
  );
};

StorePodComponent.propTypes = {
  children: node.isRequired,
  loading: bool,
  store: storeShape,
  storeId: oneOfType([string, number])
};

StorePodComponent.defaultProps = {
  loading: false,
  store: null,
  storeId: ''
};

StorePodComponent.displayName = 'StorePod';
StorePodComponent.dataModel = storeDataModel;

const HydratedComponent = withHydrator({
  delay: 500,
  id: 'store-pod',
  placeholder: (
    <Placeholder height="400px" />
  ),
  scrollBuffer: 100
}, StorePodComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);
const LayoutComponent = withLayoutGroup({ name: 'store-pod' }, DynamicComponent);

const StorePod = LayoutComponent;

StorePod.dataModel = extend(StorePodRating, storeDataModel);

export { StorePod };
